(function () {
    angular.module('app')
        .directive('equalizer', equalizer)
    function equalizer() {
        var directive = {
            restrict: 'A',
            require: '^?equalizerManager',
            link: link
        };
        return directive;
        function link($scope, $element, $attrs, equalizerManager) {
            if (equalizerManager) {
                equalizerManager.registerEqualizer($attrs.equalizer, $element);
            }
        }
    }
})();